import React from 'react'
import type { Referral } from './types'
import { formatDate, formatUSDC, shortId } from './format'

const th =
  'text-left text-xs font-semibold uppercase text-neutral-500 px-3 py-2'
const td = 'px-3 py-2 text-sm border-t border-neutral-100'

type Props = { referrals: Referral[] }

const ReferralsTable: React.FC<Props> = ({ referrals }) => {
  if (referrals.length === 0) {
    return <div className="text-sm text-neutral-600">No referrals.</div>
  }
  return (
    <div className="overflow-x-auto border border-neutral-200 rounded-lg">
      <table className="min-w-full">
        <thead className="bg-neutral-50">
          <tr>
            <th className={th}>User</th>
            <th className={th}>Attributed</th>
            <th className={th}>Volume</th>
            <th className={th}>Active</th>
            <th className={th}>Campaign</th>
          </tr>
        </thead>
        <tbody>
          {referrals.map((r) => (
            <tr key={r.privy_id}>
              <td className={td} title={r.privy_id}>
                {shortId(r.privy_id)}
              </td>
              <td className={td}>{formatDate(r.attributed_at)}</td>
              <td className={td}>{formatUSDC(r.volume_usdc)}</td>
              <td className={td}>{r.active ? 'yes' : 'no'}</td>
              <td className={td}>{r.campaign_link_label ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ReferralsTable
